<template>
    <div class="yarnboard">
        <VideoContainer :clip="clip" :nextRoute="nextRoute" />
    </div>
</template>

<script>
import VideoContainer from '@/components/VideoContainer.vue'
import Clip from '@/assets/Yarn2.mp4'

export default {
    name: 'yarnboard2',
    components: {
        VideoContainer
    },
    data() {
        return {
            clip: Clip,
            nextRoute: "/truck-sighting"
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
